(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["visio-theme"] && !Shopify.designMode) return;
  try {
    // Audit P0-2: open the cart drawer on add-to-cart. The theme's
  // `auto_open_cart_drawer` setting is unset in settings_data.json, so the
  // `auto-open` attribute never renders; cart-drawer.js only reads the
  // attribute at CartAddEvent time, so setting it here is equivalent.
  const visioAutoOpenCart = (root = document) => {
    root.querySelectorAll('cart-drawer-component:not([auto-open])').forEach((drawer) => {
      drawer.setAttribute('auto-open', '');
    });
  };

  const visioReveal = (root = document) => {
    const items = root.querySelectorAll('[data-vn-reveal]:not([data-vn-ready])');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('vn-is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('vn-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    items.forEach((item) => {
      item.dataset.vnReady = 'true';
      observer.observe(item);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      visioAutoOpenCart();
      visioReveal();
    });
  } else {
    visioAutoOpenCart();
    visioReveal();
  }

  document.addEventListener('shopify:section:load', (event) => {
    visioAutoOpenCart(event.target);
    visioReveal(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
